import React, { useState, useEffect } from 'react';
import PositionCard from './PositionCard/PositionCard';
import './PositionCard/PositionCard.css';

export default function MatchingPositionCard({ match, onView, onToggleSave, onDelete, onMatch }) {
  const { position, final_score: score } = match;
  
  // Animation state for match percentage
  const [animatedPercentage, setAnimatedPercentage] = useState(0);
  
  // Calculate match percentage
  const rawPercent = score * 100;
  const targetPercentage = rawPercent < 1 ? 0 : Math.round(rawPercent);
  
  // Animate the match percentage on mount
  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimatedPercentage(targetPercentage);
    }, 200); // Small delay before animation starts
    return () => clearTimeout(timer);
  }, [targetPercentage]);

  return (
    <div className="matching-position-wrapper">
      {/* Match percentage bar with gradient and percentage inside */}
      <div className="match-bar-container">
        {/* Empty bar with gray background */}
        <div className="match-bar-empty"></div>
        {/* Gradient fill bar that animates width */}
        <div
          className="match-bar-fill"
          style={{
            width: `${animatedPercentage}%`,
            transition: 'width 1s ease-out'
          }}
        >
          {/* Match percentage label inside the bar */}
          <div className="match-percentage-label">
            <span className="match-percentage-value">{targetPercentage}%</span>
            <span className="match-label">Match</span>
          </div>
        </div>
      </div>
      
      {/* Use the PositionCard component for everything else */}
      <PositionCard 
        position={position}
        onView={onView}
        onToggleSave={onToggleSave}
        onDelete={onDelete}
        onMatch={onMatch}
      />
      
      <style>{`
        .matching-position-wrapper {
          display: flex;
          flex-direction: column;
        }
        
        .match-bar-container {
          position: relative;
          height: 32px;
          background: #f0f0f0;
          border-radius: 6px 6px 0 0;
          overflow: hidden;
          margin-bottom: -1px; /* Connect with the PositionCard below */
          z-index: 1;
        }
        
        .match-bar-empty {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #e0e0e0;
        }
        
        .match-bar-fill {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          background: linear-gradient(135deg, #ef4444 0%, #eab308 50%, #22c55e 100%);
          display: flex;
          align-items: center;
          padding-left: 10px;
          min-width: 80px;
        }
        
        .match-percentage-label {
          display: flex;
          align-items: baseline;
          color: white;
          font-weight: bold;
          text-shadow: 0 1px 2px rgba(0,0,0,0.2);
        }
        
        .match-percentage-value {
          font-size: 16px;
          margin-right: 4px;
        }
        
        .match-label {
          font-size: 12px;
        }
      `}</style>
    </div>
  );
}